<template>
  <div class="eplaceholder-cont">
    <div class="emoji-cont">
      <positive-emoji-icon v-if="type=='positive'" class="icon-default emoji positive-emoji"></positive-emoji-icon>
      <neutral-emoji-icon v-else class="icon-default emoji neutral-emoji"></neutral-emoji-icon>
    </div>
    <div class="title-cont">
      {{title}}
    </div>
    <div class="desc-cont">
      {{description}}
    </div>
  </div>
</template>

<script>
import NeutralEmojiIcon from '../../assets/neutralemoji.svg';
import PositiveEmojiIcon from '../../assets/positiveemoji.svg';

export default {
  name: 'EmptyPlaceholder',
  props: ['text', 'type', 'title', 'buttonText'],
  data() {
    return {
      description: ''
    };
  },
  components: {
    NeutralEmojiIcon,
    PositiveEmojiIcon
  },
  created() {
    if (typeof this.text === 'function') {
      this.description = this.text();
    } else {
      this.description = this.text;
    }
  },
  methods: {}
};
</script>

<style>
</style>
